import { useState, createContext, useEffect } from "react";
import { Routes, Route, useNavigate } from "react-router-dom";
import { message, Modal, Button } from "antd";
import { Web3Provider, useWeb3 } from "./contexts/Web3Context";
import { ethers } from "ethers";
// Component imports
import Homepage from "./components/Homepage2";
import Dashboard from "./components/Dashboard";
import Teams from "./components/Teams";
import BinaryTree from "./components/BinaryTree";
import Admin from "./components/Admin";
import Red from "./components/Red";
import Downline from "./components/Downline";
import Test from "./components/Test";
import Register from "./components/Register";
import NetworkStatus from "./components/NetworkStatus";
import Home from "./components/Home";
// Create Context for App-specific state
const AppState = createContext();
// Ranks Configuration
const RANKS = [
 "L1", "L2", "L3", "L4",
 "L5", "L6", "L7", "L8",
 "L9", "L10", "L11", "L12",
];
function AppContent() {
 // App-specific states
 const [id, setId] = useState("0");
 const [theme, setTheme] = useState("dark");
 const [change, setChange] = useState(0);
 const [levels, setLevels] = useState(Array(12).fill(0));
 const [percent, setPercent] = useState(Array(12).fill(0));
 const [shown, setShown] = useState(false);
 const [loaded, setLoaded] = useState(false);
 const [isModalOpen, setIsModalOpen] = useState(false);
 const [bal, setBal] = useState(0);
 const [bal2, setBal2] = useState(0);
 const [bal3, setBal3] = useState(0);
  // Get Web3 context
 const { 
   staticContract, 
   walletAddress, 
   provider,
   contractAddresses,
   convert,
   formatTime,
   getUTCTime,
   isContractReady,
   isWalletConnected,
   disconnectWallet
 } = useWeb3();
  const navigate = useNavigate();
  const toggle = () => {
   const newTheme = theme === "dark" ? "light" : "dark";
   setTheme(newTheme);
   localStorage.setItem("theme", newTheme);
 };
  const Login = async () => {
   try {
     if (!walletAddress || !staticContract) return;
      const userId = await staticContract.id(walletAddress);
     if (Number(userId) === 0) {
       message.error("User Not Registered");
       return;
     }
      message.success("Logged In");
     navigate("/dashboard");
   } catch (error) {
     message.error("Login failed");
   }
 };



  const Logout = async () => {
    await disconnectWallet();
    navigate("/");
  };

  // Load contract data
 useEffect(() => {
   const loadContractData = async () => {
     if (!staticContract || !walletAddress) return;
      try {
       // Get user ID
       const userId = await staticContract.id(walletAddress);
       setId(Number(userId));
        // Get levels
       const [amounts, percentages] = await staticContract.getLevels();
       setLevels([0, ...amounts.map((amount) => Number(ethers.formatEther(amount)))]);
       setPercent([0, ...percentages.map((p) => Number(p))]);
        // Get balances
       if (provider) {
         const [balance, feeBalance, royaltyBalance] = await Promise.all([
           provider.getBalance(walletAddress),
           provider.getBalance(contractAddresses.fee),
           provider.getBalance(contractAddresses.royalty),
         ]);
          setBal(convert(balance));
         setBal2(convert(feeBalance));
         setBal3(convert(royaltyBalance));
       }
        setLoaded(true);
     } catch (error) {
       console.error("Error loading contract data:", error);
     }
   };
    loadContractData();
 }, [staticContract, walletAddress, provider]);
  // Load theme from localStorage
 useEffect(() => {
   const savedTheme = localStorage.getItem("theme");
   if (savedTheme) setTheme(savedTheme);
 }, []);
  // Context value

  
 const contextValue = {
   id,
   theme,
   change,
   setChange,
   bal,
   bal2,
   bal3,
   levels,
   percent,
   ranks: RANKS,
   loaded,
   shown,
   setShown,
   formatTime,
   getUTCTime,
   toggle,
   Login,
   navigate,
   convert,
   staticContract,
   isContractReady,
   isWalletConnected,
   Logout
 };
  return (
   <AppState.Provider value={contextValue}>
     <div className={`App bg-dark ${theme}`}>
       {/* <NetworkStatus provider={provider} /> */}
        <Modal
         title={<div className="text-2xl font-semibold text-blue-600">📢 Dear MBNers</div>}
         open={isModalOpen}
         onOk={() => setIsModalOpen(false)}
         onCancel={() => setIsModalOpen(false)}
         centered
         className="welcome-modal"
         footer={[
           <Button
             key="close"
             onClick={() => setIsModalOpen(false)}
             className="bg-blue-600 text-white hover:bg-blue-500"
           >
             Close
           </Button>,
         ]}
         width={600}
       >
         <div className="p-2 text-gray-700">
           {/* Modal content here */}
         </div>
       </Modal>
        <Routes>
         <Route path="/" element={<Home />} />         
         <Route path="/dashboard" element={<Dashboard />} />
         <Route path="/team" element={<Teams />} />
         <Route path="/matrix" element={<BinaryTree />} />
         <Route path="/skhindi" element={<Admin />} />
         <Route path="/sosizi" element={<Red />} />
         <Route path="/downline" element={<Downline />} />
         <Route path="/test" element={<Test />} />
         <Route path="/register" element={<Register />} />
       </Routes>
     </div>
   </AppState.Provider>
 );
}

function App() {
 return (
   <Web3Provider>
     <AppContent />
   </Web3Provider>
 );
}

export default App;
export { AppState };
